import { render, staticRenderFns } from "./WhatsAppTemplateMessage.vue?vue&type=template&id=a1d53792"
import script from "./WhatsAppTemplateMessage.vue?vue&type=script&lang=js"
export * from "./WhatsAppTemplateMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports